// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgBenefitCardPatternXxs3 = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width={144}
    height={144}
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_1505_4345)" fill="#C2E0FF" fillOpacity={0.2}>
      <path d="M144 143.987v-4.002c-17.431-.519-31.466-14.554-31.985-31.985h-4.002c.521 19.64 16.347 35.466 35.987 35.987Z" />
      <path d="M116.017 108c.516 15.221 12.762 27.467 27.983 27.983v-4.003c-13.012-.512-23.469-10.968-23.98-23.98h-4.003Z" />
      <path d="M124 108c0 11.046 8.954 20 20 20v-4c-8.837 0-16-7.163-16-16h-4Z" />
      <path d="M132 108c0 6.627 5.373 12 12 12v-4a8 8 0 0 1-8-8h-4ZM140 108a4 4 0 0 0 4 4v-4h-4Z" />
    </g>
    <g clipPath="url(#clip1_1505_4345)" fill="#BCD5FA" fillOpacity={0.08}>
      <path d="M72 140H36v4h36v-4ZM72 108H36v4h36v-4ZM36 116h36v4H36v-4ZM72 132H36v4h36v-4ZM36 124h36v4H36v-4Z" />
    </g>
    <path
      d="M108 108h-4v-4h4v4ZM96 88h4v4h-4v-4ZM92 88v4h-4v-4h4ZM92 84v4h4v-4h4v-4h-4v4h-4ZM88 84v-4h4v4h-4ZM84 84h4v4h-4v-4ZM84 92h-4v-4h4v4ZM84 96h-4v4h4v-4ZM84 96v-4h4v4h-4ZM84 84v-4h-4v4h4Z"
      fill="#BCD5FA"
      fillOpacity={0.08}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100 104h4v-4h4v-4h-4v-4h4v-4h-4v-4h4v-4h-4v-4h4v-4h-4v4h-4v-4h-4v4h-4v-4h-4v4h-4v-4h-4v4h-4v-4h-4v4h4v4h-4v4h4v4h-4v4h4v4h-4v4h4v4h-4v4h4v-4h4v4h4v-4h4v4h4v-4h4v4h4v-4Zm0-4v4h-4v-4h4Zm0-4v4h4v-4h-4Zm-4 0v4h-4v-4h4Zm0-4v4h4v-4h4v-4h-4v-4h4v-4h-4v-4h-4v4h-4v-4h-4v4h-4v-4h-4v4h-4v4h4v4h-4v4h4v4h-4v4h4v4h4v-4h4v4h4v-4h-4v-4h4v-4h4Z"
      fill="#BCD5FA"
      fillOpacity={0.08}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.077 74.82V72h-2.82L.077 105.18V108h2.82l33.18-33.18Zm-36 24.54v-5.627L21.81 72h5.627L.077 99.36Zm0-16.82v5.66l16.2-16.2h-5.66L.077 82.54Zm0-10.54h5.04l-5.04 5.04V72Zm8.64 36h5.627l21.733-21.733V80.64L8.717 108Zm16.82 0h-5.66l16.2-16.2v5.66L25.537 108Zm10.54-5.04-5.04 5.04h5.04v-5.04ZM107.923 69.18V72h2.82l33.18-33.18V36h-2.819l-33.181 33.18Zm36-24.54v5.627L122.19 72h-5.627l27.36-27.36Zm0 16.82V55.8l-16.2 16.2h5.66l10.54-10.54Zm0 10.54h-5.04l5.04-5.04V72Zm-8.64-36h-5.627l-21.733 21.733v5.627L135.283 36Zm-16.82 0h5.66l-16.2 16.2v-5.66L118.463 36Zm-10.54 5.04 5.04-5.04h-5.04v5.04Z"
      fill="#C2E0FF"
      fillOpacity={0.2}
    />
    <path
      d="M36 36h4v4h-4v-4ZM48 56h-4v-4h4v4ZM52 56v-4h4v4h-4ZM52 60v-4h-4v4h-4v4h4v-4h4ZM56 60v4h-4v-4h4ZM60 60h-4v-4h4v4ZM60 52h4v4h-4v-4ZM60 48h4v-4h-4v4ZM60 48v4h-4v-4h4ZM60 60v4h4v-4h-4Z"
      fill="#BCD5FA"
      fillOpacity={0.08}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44 40h-4v4h-4v4h4v4h-4v4h4v4h-4v4h4v4h-4v4h4v-4h4v4h4v-4h4v4h4v-4h4v4h4v-4h4v4h4v-4h-4v-4h4v-4h-4v-4h4v-4h-4v-4h4v-4h-4v-4h4v-4h-4v4h-4v-4h-4v4h-4v-4h-4v4h-4v-4h-4v4Zm0 4v-4h4v4h-4Zm0 4v-4h-4v4h4Zm4 0v-4h4v4h-4Zm0 4v-4h-4v4h-4v4h4v4h-4v4h4v4h4v-4h4v4h4v-4h4v4h4v-4h4v-4h-4v-4h4v-4h-4v-4h4v-4h-4v-4h-4v4h-4v-4h-4v4h4v4h-4v4h-4Z"
      fill="#BCD5FA"
      fillOpacity={0.08}
    />
    <g clipPath="url(#clip2_1505_4345)" fill="#BCD5FA" fillOpacity={0.08}>
      <path d="M72 4h36V0H72v4ZM72 36h36v-4H72v4ZM108 28H72v-4h36v4ZM72 12h36V8H72v4ZM108 20H72v-4h36v4Z" />
    </g>
    <g clipPath="url(#clip3_1505_4345)" fill="#C2E0FF" fillOpacity={0.2}>
      <path d="M0 .013v4.002C17.43 4.534 31.466 18.569 31.985 36h4.002C35.466 16.36 19.64.534 0 .013Z" />
      <path d="M27.983 36C27.467 20.78 15.221 8.533 0 8.017v4.003C13.012 12.53 23.468 22.988 23.98 36h4.003Z" />
      <path d="M20 36c0-11.046-8.954-20-20-20v4c8.837 0 16 7.163 16 16h4Z" />
      <path d="M12 36c0-6.627-5.373-12-12-12v4a8 8 0 0 1 8 8h4ZM4 36a4 4 0 0 0-4-4v4h4Z" />
    </g>
    <defs>
      <clipPath id="clip0_1505_4345">
        <path fill="#fff" transform="rotate(-180 72 72)" d="M0 0h36v36H0z" />
      </clipPath>
      <clipPath id="clip1_1505_4345">
        <path fill="#fff" transform="matrix(1 0 0 -1 36 144)" d="M0 0h36v36H0z" />
      </clipPath>
      <clipPath id="clip2_1505_4345">
        <path fill="#fff" transform="matrix(-1 0 0 1 108 0)" d="M0 0h36v36H0z" />
      </clipPath>
      <clipPath id="clip3_1505_4345">
        <path fill="#fff" d="M0 0h36v36H0z" />
      </clipPath>
    </defs>
  </svg>
))
SvgBenefitCardPatternXxs3.displayName = 'SvgBenefitCardPatternXxs3'
const Memo = memo(SvgBenefitCardPatternXxs3)
export { Memo as SvgBenefitCardPatternXxs3 }
